/**
 * Removes keys with `undefined` values from an object by round-tripping
 * through JSON. Keys with `null` values are preserved.
 *
 * @param {Record<never, never>} object - The object to clean
 * @returns {Record<never, never>} A new object without `undefined` values
 */
export function removeUndefinedValues(object: Record<never, never>): Record<never, never> {
    return JSON.parse(JSON.stringify(object));
}
